import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  BancoPlazaService,
  BancoPlazaTransaction,
} from '../../../services/banco-plaza.service';

@Component({
  selector: 'app-banco-plaza-transaction-detail-modal',
  templateUrl: './banco-plaza-transaction-detail-modal.component.html',
  styleUrls: ['./banco-plaza-transaction-detail-modal.component.sass'],
})
export class BancoPlazaTransactionDetailModalComponent implements OnInit {
  loading = true;
  tx: BancoPlazaTransaction | null = null;
  error: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private dialogRef: MatDialogRef<BancoPlazaTransactionDetailModalComponent>,
    private bp: BancoPlazaService,
  ) {}

  ngOnInit(): void {
    this.bp.getTransaction(this.data.id).subscribe({
      next: (res) => {
        this.tx = res.data;
        this.loading = false;
      },
      error: (err) => {
        this.error = typeof err === 'string' ? err : 'Error cargando transacción';
        this.loading = false;
      },
    });
  }

  /** Nombre completo del cliente, sin dejar un espacio suelto si falta uno. */
  get clienteNombre(): string {
    const c = this.tx?.cliente;
    if (!c) return '';
    return [c.nombre, c.apellidos].filter(Boolean).join(' ');
  }

  /**
   * Si hay algo que mostrar en el bloque de nuestro lado. Un cargo del banco
   * no tiene ni cliente ni beneficiario, y sin esto quedaba un hueco vacío.
   */
  get hayContraparte(): boolean {
    return !!(
      this.tx?.cliente ||
      this.tx?.beneficiario ||
      this.tx?.referenciaVes
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  getStatusClass(status: string): string {
    return `status-${status?.toLowerCase()}`;
  }

  getStatusLabel(status: string): string {
    return {
      PENDING: 'Pendiente',
      PENDING_BCV: 'Pendiente BCV',
      PENDING_VERIFICATION: 'Verificando',
      APPROVED: 'Aprobada',
      REJECTED: 'Rechazada',
      EXPIRED: 'Expirada',
    }[status] || status;
  }

  getTipoLabel(tipo: string): string {
    return {
      PAYIN: 'Payin',
      PAYOUT: 'Payout',
      PAYOUT_OWNBANK: 'Payout · Mismo banco',
      PAYOUT_OTHERBANK: 'Payout · Otro banco',
      PAYOUT_P2P: 'Payout · Pago Móvil',
      CARGO_BANCARIO: 'Cargo del banco',
    }[tipo] || tipo;
  }
}
